import React from "react";
import { formatPalletLabel } from "../helpers/formatPallet";

// Aviso de los pallets que no aparecen en una lista por la fecha y hora de un
// reloj con desfase. El motivo llega en singular y en plural porque el verbo
// concuerda con la cantidad de pallets
export const AvisoPalletsOcultos = ({
    pallets,
    motivoSingular,
    motivoPlural,
}) => {
    if (!pallets || pallets.length === 0) return null;

    const mensaje =
        pallets.length === 1
            ? `1 pallet no se muestra porque ${motivoSingular}`
            : `${pallets.length} pallets no se muestran porque ${motivoPlural}`;

    return (
        <div className="alert alert-warning text-center font-weight-bold mt-3">
            {`${mensaje}: `}
            {/* cada pallet va sin cortes de línea, que solo caen entre uno y
                otro, después de la coma */}
            {pallets.map((pallet, index) => (
                <React.Fragment key={index}>
                    <span className="text-nowrap">
                        {formatPalletLabel(
                            pallet.numero,
                            pallet.identificador_fisico,
                        )}
                        {index < pallets.length - 1 ? "," : "."}
                    </span>
                    {index < pallets.length - 1 ? " " : null}
                </React.Fragment>
            ))}
        </div>
    );
};
